import styled, { css } from 'styled-components';
import ContentItem from '../ContentItem/ContentItem';
import { device } from '../breakpoints';
import { imgPadding16By9 } from '../PlayImage/PlayImage.styles';
import { playGrey10 } from '../design-tokens';

export const StyledContentItemGrid = styled.div`
    overflow: visible;
    white-space: normal;
    padding: 2px;
    width: 100%;
    clear: both;
    margin-top: 2px;
    display: block;
`;

export const ContentItemGridBlock = styled(ContentItem)`
    margin-bottom: 20px;

    ${(props) =>
        !props.inView &&
        css`
            background: ${playGrey10};
            height: 0;
            padding: calc((${imgPadding16By9} - 5px) / 2) 0;
            margin-bottom: 74px;

            @media ${device.GteMedium} {
                padding: calc((${imgPadding16By9} - 5px) / 3) 0;
            }

            @media ${device.GteLarge} {
                padding: calc((${imgPadding16By9} - (3 * 11px)) / 4) 0;
            }

            @media ${device.GteXLarge} {
                padding: calc((${imgPadding16By9} - (3 * 11px)) / 5) 0;
            }

            @media ${device.FullScreen} {
                padding: calc((${imgPadding16By9} - (5 * 11px)) / 6) 0;
            }
        `}

    overflow: visible;
    margin-right: 5px;
    &:nth-child(2n) {
        margin-right: 0;
    }

    margin-left: 0;

    clear: both;
    width: calc((100% - 5px) / 2);

    @media ${device.GteMedium} {
        width: calc((100% - (2 * 5px)) / 3);
        margin-right: 5px;

        &:nth-child(2n) {
            margin-right: 5px;
        }

        &:nth-child(3n) {
            margin-right: 0;
        }

        margin-left: 0;
    }

    @media ${device.GteLarge} {
        width: calc((100% - (3 * 11px)) / 4);
        margin-right: 10px;

        &:nth-child(2n) {
            margin-right: 10px;
        }

        &:nth-child(3n) {
            margin-right: 10px;
        }

        &:nth-child(4n) {
            margin-right: 0;
        }
    }

    @media ${device.GteXLarge} {
        width: calc((100% - (4 * 11px)) / 5);

        &:nth-child(4n) {
            margin-right: 10px;
        }

        &:nth-child(5n) {
            margin-right: 0;
        }
    }

    @media ${device.FullScreen} {
        width: calc((100% - (5 * 11px)) / 6);

        &:nth-child(5n) {
            margin-right: 10px;
        }

        &:nth-child(6n) {
            margin-right: 0;
        }
    }
`;
